/*
    Creation Time: 2021 - Sep - 26
    Created by:  (hamidrezakk)
    Maintainers:
       1.  HamidrezaKK (hamidrezakks@gmail.com)
    Auditor: HamidrezaKK
    Copyright Qlub_ 2022
*/

export function capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const toRedirect = (str: string) => {
    return str.split('\n').map((item) => {
        const [old, cur] = item.split('\t');
        return {
            source: old,
            destination: cur,
            type: 301,
        };
    });
};

export const kTrimEnd = (str: string, chars: string) => {
    const idx = str.lastIndexOf(chars);
    if (idx > -1 && idx + chars.length === str.length) {
        return str.split(chars)[0];
    }
    return str;
};

export const kDecodeString = (str: string, retry = 0): string => {
    const s = decodeURIComponent(str);
    if (s.includes('%') && retry <= 3) {
        return kDecodeString(s, retry + 1);
    }
    return s;
};

export const commafy = (num: any, fix?: number) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(num)) {
        num = 0.0;
    }
    fix = fix || 0;
    if (num === null) {
        return '0';
    }
    if (!Number.isInteger(num)) {
        num = Number(num).toFixed(fix);
    } else {
        num = String(num);
    }

    return num.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
};
